import { IReportService } from "../../service/report/ReportService";

export default class GetFormStructureInteractor {
  private reportService: IReportService;

  constructor(reportService) {
    this.reportService = reportService;
  }

  async execute(formTypeCode: string) {
    return this.reportService.getFormStructure(formTypeCode);
  }
}
